<script setup lang="ts">
/**
 * Renders the teleport targets for every app-drawer subscriber.
 *
 * Extracted from `App.vue` so a failure while rendering the rail is a *child*
 * error the app can contain, rather than a root render error that wedges
 * `<RouterView>`. The boundary lives HERE, on the rail component, not on
 * `App.vue` — an `onErrorCaptured` at the root catches (and would swallow) every
 * descendant error, including `<RouterView>`'s, and mislabel it as a rail
 * failure.
 */
import { useAppDrawer } from "@blackfisk/vue/composables/useAppDrawer";
import { useLogger } from "@blackfisk/vue/composables/useLogger";
import { onErrorCaptured } from "vue";

const { subscribers } = useAppDrawer();

const logger = useLogger("client-frontend", "app-drawer");

onErrorCaptured((error) => {
  logger.error("App drawer rail render error: {error} | {stack}", {
    error,
    stack: error instanceof Error ? error.stack : "",
  });
  return false;
});
</script>

<template>
  <template v-for="drawerSubscriber in subscribers" :key="drawerSubscriber.id">
    <div :id="drawerSubscriber.target" class="contents" />
  </template>
</template>
